import { Button, Grid, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import { useState, useEffect } from "react";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import BasicTextField from "../forms/formElements/BasicTextField";
import { roleActions } from "../../redux/slices/roleSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../redux/hooks";
import { loginCognitoActions } from "../../redux/slices/loginSlice";
import MerchantProfile from "../merchant/MerchantProfile";
import { adminActions } from "../../redux/slices/adminSlice";
import { financeActions } from "../../redux/slices/financeSlice";
import { loyaltyPointsActions } from "../../redux/slices/LoyaltyPointsSlice";
import { memberActions } from "../../redux/slices/memberSlice";
import { merchantActions } from "../../redux/slices/merchantSlice";
import { receiptsActions } from "../../redux/slices/recieptsSlice";
import { salesActions } from "../../redux/slices/SalesSlice";
import { shopUserActions } from "../../redux/slices/shopUserSlice";
import { stopSession } from "../../services/interceptors/ApiInterceptor";
export interface UpdateAdminProps {
  initialFormData: UpdateAdminDataType;
}
export interface UpdateAdminDataType {
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  user_role: string;
  email: string;
  status: string;
  designation: String;
  department: string;
}

export function Profile(props: UpdateAdminProps) {
  const dispatch = useDispatch();
  const { initialFormData } = props;
  const [selectState, setSelectState] = useState("");
  const buttonStyles = useButtonStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [roles, setRoles] = useState<string[]>([]);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [merchant, setMerchant] = useState(false);
  const navigate = useNavigate();
  const [updateAdminFormState, setAdminFormState] =
    useState<UpdateAdminDataType>(initialFormData);
  const resetPersistStates = () => {
    dispatch(adminActions.resetAdminState());
    dispatch(financeActions.resetFinanceReset());
    dispatch(loginCognitoActions.resetLoginState());
    dispatch(loyaltyPointsActions.resetLoyaltyState());
    dispatch(memberActions.resetMemberSlice());
    dispatch(merchantActions.resetMerchantSlice());
    dispatch(receiptsActions.resetReceiptsState());
    dispatch(roleActions.resetRoleSlice());
    dispatch(salesActions.resetSalesSlice());
    dispatch(shopUserActions.resetShopUserSlice());
  };
  const handleLogout = async () => {
    setLoading(true);
    resetPersistStates();
    setTimeout(() => {
      sessionStorage.clear();
      stopSession()
      localStorage.clear();
      navigate("/login");
    }, 1000);
  };

  const HandleUpdateAdmin = async () => {
    setLoading(true);
    try {
      const response = await axios.patch(
        process.env.REACT_APP_API_URL + APIConstants.admin,
        updateAdminFormState
      );
      if (response.data.message) {
        setShowModal(true);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const firstName = useAppSelector(
    (state: any) => state.persistReducers.login.firstName
  );
  const lastName = useAppSelector(
    (state: any) => state.persistReducers.login.lastName
  );
  const email = useAppSelector(
    (state: any) => state.persistReducers.login.email
  );
  const department = useAppSelector(
    (state: any) => state.persistReducers.login.department
  );
  const userRole = useAppSelector(
    (state: any) => state.persistReducers.login.userRole
  );
  const groups = localStorage.getItem("groups");
  const userRoleGroup = groups ? JSON.parse(groups) : [];

  useEffect(() => {
    if (userRoleGroup.find((role: any) => role.includes("merchant"))) {
      setMerchant(true);
    }
  }, []);
  return merchant ? (
    <MerchantProfile />
  ) : (
    <Grid>
      <Grid
        display={"flex"}
        container
        justifyContent={"space-between"}
        height={"6.25rem"}
        borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
        sx={{
          backgroundColor: theme?.color?.background,
          "&:hover:not(.Mui-disabled)": {
            cursor: "pointer",
          },
        }}
      >
        <Grid
          item
          display={"flex"}
          px={4}
          gap={2}
          justifyContent={"left"}
          alignItems={"center"}
        >
          <Typography
            variant="h6"
            sx={{
              color: theme?.color?.primary,
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: "600",
            }}
          >
            My Profile
          </Typography>
        </Grid>
        <Grid item display={"flex"} alignItems={"center"} mr={4}>
          <Button
            sx={{ ...buttonStyles.outlinedDanger }}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Grid>
      </Grid>

      {/* ProfileForm */}
      <Grid
        sx={{
          backgroundColor: theme.color?.background,
          borderRadius: "16px",
        }}
        m={4}
        paddingLeft={8}
        pt={8}
        pb={8}
      >
        <Grid container gap={4}>
          <Grid item container gap={6}>
            <Grid item md={5.5}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                First Name *
              </Typography>
              <BasicTextField
                placeholder=""
                stateKey="firstName"
                setState={setAdminFormState}
                defaultValue={firstName}
              ></BasicTextField>
            </Grid>
            <Grid item md={5.5}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Last Name *
              </Typography>
              <BasicTextField
                placeholder=""
                stateKey="lastName"
                setState={setAdminFormState}
                defaultValue={lastName}
              ></BasicTextField>
            </Grid>
          </Grid>

          <Grid item container gap={6}>
            <Grid item md={5.5}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Email
              </Typography>
              <BasicTextField
                readonly
                placeholder=""
                stateKey="email"
                setState={setAdminFormState}
                defaultValue={email}
              />
            </Grid>
            <Grid item md={5.5}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                User Role
              </Typography>
              <BasicTextField
                readonly
                placeholder=""
                stateKey="user_role"
                setState={setAdminFormState}
                defaultValue={userRole}
              />
         
            </Grid>
          </Grid>

          <Grid item container>
            <Grid item md={5.5}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Department
              </Typography>
              <BasicTextField
                readonly
                placeholder=""
                stateKey="department"
                setState={setAdminFormState}
                defaultValue={department}
              />
            </Grid>
          </Grid>

          <Grid item container mr={6} justifyContent={"end"} padding={2}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary, width: "23%", mr: 2 }}
              variant="outlined"
              component={Link}
              to="/dashboard"
            >
              Cancel
            </Button>
            <Button
              type="button"
              sx={{ ...buttonStyles.containedSecondary, width: "23%" }}
              variant="contained"
              onClick={HandleUpdateAdmin}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {uploadError && (
        <BasicModal
          title={"Something went wrong"}
          success={false}
          setState={setUploadError}
        />
      )}
      {loading && <BasicModal content={<Loader />} />}
      {showModal && (
        <BasicModal
          title={"Admin Updated Successfully!"}
          success={true}
          setState={setShowModal}
        />
      )}
    </Grid>
  );
}
